import { render, staticRenderFns } from "./galleryItem.vue?vue&type=template&id=00503a6e&"
import script from "./galleryItem.vue?vue&type=script&lang=js&"
export * from "./galleryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports